"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";

const TEXTURE_MIN = 1;
const TEXTURE_MAX = 18;

export function PaperSwitcher() {
  const params = useSearchParams();
  const paper = params.get("paper");
  const opacity = params.get("paperOpacity");

  useEffect(() => {
    const root = document.documentElement;

    const paperNum = paper === null ? NaN : Number(paper);
    if (
      Number.isInteger(paperNum) &&
      paperNum >= TEXTURE_MIN &&
      paperNum <= TEXTURE_MAX
    ) {
      const n = String(paperNum).padStart(2, "0");
      root.style.setProperty("--paper-bg", `url("/textures/grainy/${n}.jpg")`);
    } else {
      root.style.removeProperty("--paper-bg");
    }

    const parsedOpacity = opacity === null ? NaN : Number(opacity);
    if (Number.isFinite(parsedOpacity)) {
      const clamped = Math.min(1, Math.max(0, parsedOpacity));
      root.style.setProperty("--paper-opacity", String(clamped));
    } else {
      root.style.removeProperty("--paper-opacity");
    }
  }, [paper, opacity]);

  return null;
}
